/* eslint-disable @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types */
import { useMemo } from 'react';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { mdModule } from '@next-common/breakpoint';
import { env } from '@next-common/shared-util';
import { regroupModuleReducers } from './regroupModuleReducers';
// @ts-expect-error middleware
const bindMiddleware = (middleware) => {
    // use in dev only
    const reduxDevToolOptions = () => {
        if (env.isDev()) {
            return { trace: true, traceLimit: 25 };
        }
        return {};
    };
    let composeEnhancers = compose;
    if (env.isDev() && !env.isTest() && !env.isNode()) {
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            // eslint-disable-line no-underscore-dangle
            composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(reduxDevToolOptions()) || compose; // eslint-disable-line no-underscore-dangle
        }
    }
    return composeEnhancers(applyMiddleware(...middleware));
};
if (typeof window !== 'undefined') {
    window.API_MANIFEST = window.API_MANIFEST || {};
}
let store;
const defaultInitialState = {};
const defaultReducer = regroupModuleReducers([mdModule]);
const createReducer = (newReducers) => combineReducers(Object.assign(Object.assign({}, newReducers), defaultReducer));
function initStore(preloadedState = defaultInitialState, initalAsyncreducers) {
    const reducers = createReducer(initalAsyncreducers);
    // @ts-expect-error Store
    const myStore = createStore(reducers, preloadedState, bindMiddleware([thunkMiddleware]));
    // Add a dictionary to keep track of the registered async reducers
    myStore.asyncReducers = Object.assign({}, initalAsyncreducers);
    // Create an inject reducer function
    // This function adds the async reducer, and creates a new combined reducer
    myStore.injectReducer = (key, asyncReducer, newAsyncReducerState) => {
        myStore.asyncReducers[key] = asyncReducer;
        const newReducers = createReducer(myStore.asyncReducers);
        const mainReducer = (state = {}, action) => {
            if (action.type === 'hydrate') {
                if (action.payload.newAsyncReducerState) {
                    // @ts-expect-error Store
                    state[action.payload.key] = action.payload.newAsyncReducerState;
                }
                return state;
            }
            return newReducers(state, action);
        };
        myStore.replaceReducer(mainReducer);
        myStore.dispatch({
            type: 'hydrate',
            payload: {
                key,
                newAsyncReducerState,
            },
        });
    };
    return myStore;
}
export const initializeStore = (preloadedState, newReducers) => {
    let tempstore;
    if (store) {
        Object.entries(newReducers).map(([key, reducer]) => {
            let preLaodedStoreforReducer;
            if (preloadedState && preloadedState[key]) {
                preLaodedStoreforReducer = preloadedState[key];
            }
            store.injectReducer(key, reducer, preLaodedStoreforReducer);
        });
        tempstore = store;
    }
    else {
        tempstore = initStore(preloadedState, newReducers);
    }
    // After navigating to a page with an initial Redux state, merge that state
    // with the current state in the store, and create a new store
    // if (preloadedState && store) {
    //   tempstore = initStore(
    //     {
    //       ...store.getState() as {} ,
    //       ...preloadedState,
    //     },
    //     newReducers
    //   );
    //   // Reset the current store
    //   store = undefined;
    // }
    // For SSG and SSR always create a new store
    if (typeof window === 'undefined') {
        return tempstore;
    }
    // Create the store once in the client
    if (typeof window !== 'undefined') {
        store = tempstore;
        // window.__rakuten__redux__store__ = store
    }
    return tempstore;
};
export const useStore = (initialState, newReducers) => {
    return useMemo(() => initializeStore(initialState, newReducers), [initialState]);
};
